export default __webpack_public_path__ + "images/models/836c2fe65d711c31ca700201e51c527d.glb";